/*** IMPORTS FROM imports-loader ***/
(function() {

require('./angulartics-google-tag-manager');
module.exports = 'angulartics.google.tagmanager';


/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;
}.call(window));